import { testimonials } from "@/mocks/site";

export default function Testimonials() {
  return (
    <section aria-labelledby="voice-title" className="px-4 py-12 md:px-6 md:py-16">
      <div className="mb-7 text-center">
        <p className="mb-2 text-xs font-medium tracking-[0.25em] text-secondary-600">READERS SAY</p>
        <h2 id="voice-title" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          瓜友怎么说
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {testimonials.map((item, index) => (
          <figure
            key={item.name}
            className={`rounded-lg border p-5 md:p-6 ${
              index % 3 === 0
                ? "border-background-200 bg-background-50"
                : index % 3 === 1
                  ? "border-accent-300 bg-accent-100/60"
                  : "border-background-200 bg-secondary-50"
            }`}
          >
            <i className="ri-double-quotes-l text-xl text-primary-400" aria-hidden="true" />
            <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
              {item.text}
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                {item.name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}